let counter = 0;

/** Deterministic-per-session id generator for ARIA relationships when React's useId is unavailable. */
export function nextId(prefix = 'zo'): string {
  counter += 1;
  return `${prefix}-${counter.toString(36)}`;
}

/** UUID v4-ish generator with a fallback for non-secure contexts. */
export function uuid(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}
